import { Component, OnInit, LOCALE_ID, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AccountService, ICategory, IRecentSupplier, IUser, IAccount } from '../../shared/account.service';
import { Account } from '../../shared/account.model';
import { FormBuilder, Validators } from '@angular/forms';
import { RecentSupplier } from '../../../recent-supplier/shared/recent-supplier.model';
import { Observable, of, Subject, forkJoin } from 'rxjs';
import { startWith, map, mergeMap, take, tap, switchMap } from 'rxjs/operators';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';
import { ICustomVisionResponse, CustomVisionService, IPrediction } from '../../../shared/custom-vision.service';
import { ComputerVisionService } from '../../../shared/computer-vision.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD',
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'YYYY年M月',
    dateA11yLabel: 'YYYY/MM/DD',
    monthYearA11yLabel: 'YYYY年M月',
  },
};

@Component({
  selector: 'app-account-wizard-form',
  templateUrl: './account-wizard-form.component.html',
  styleUrls: ['./account-wizard-form.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AccountWizardFormComponent implements OnChanges, OnInit {

  @Input() receipt?: File;
  receiptChangeSource = new Subject<File>();
  receiptChange$ = this.receiptChangeSource.asObservable();

  maxDate = new Date();
  me?: IUser;
  suppliers$?: Observable<IRecentSupplier[]>;

  //predictions$?: Observable<IPrediction[]>;
  predictions: IPrediction[] = [];
  users$?: Observable<IUser[]>;
  categories$?: Observable<ICategory[]>;
  filteredSuppliers$?: Observable<RecentSupplier[]>;

  constructor(
    private _formBuilder: FormBuilder,
    private _accountService: AccountService,
    private _computerVisionService: ComputerVisionService,
    private _customVisionService: CustomVisionService,
  ) { }

  formGroup = this._formBuilder.group({
    amount: ['', Validators.required],
    paidOn: ['', Validators.required],
    category: ['', Validators.required],
    supplierName: ['', Validators.required],
    paidBy: ['', Validators.required],
    notes: [],
  });

  public getAccount() {
    return this.formGroup?.value as Account;
  }

  compareFn(option1: any, option2: any) {
    return option1 && option2 ? option1.id === option2.id : option1 === option2;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.receipt && typeof (changes.receipt) !== 'undefined') {
      this.formGroup.reset();
      this.formGroup.patchValue({
        paidBy: this.me ?? {},
      });
      this.receiptChangeSource.next(this.receipt);
    }
  }

  async ngOnInit() {
    this.me = await this._accountService.whoAmI();
    this.suppliers$ = this._accountService.retrieveRecentSuppliers().pipe(map(value => value.entities));
    this.filteredSuppliers$ = this.suppliers$.pipe(
      mergeMap(suppliers =>
        (this.formGroup?.get('supplierName')?.valueChanges ?? of()).pipe(
          startWith(''),
          map(name => suppliers.filter(s => (s.supplierName ?? '').startsWith(name ?? '')).slice(0, 10) ?? []),
        )
      )
    );

    this.suppliers$.pipe(
      mergeMap(suppliers =>
        (this.formGroup?.get('supplierName')?.valueChanges ?? of()).pipe(
          map(name => this.formGroup.get('category')?.setValue(
            suppliers.find(s => s.supplierName === name)?.category
          )),
        )
      )
    ).subscribe();

    this.receiptChange$.pipe(
      mergeMap(receipt => forkJoin([
        this._computerVisionService.ocr(receipt).pipe(
          map(value => this._computerVisionService.analyzeResponse(value))
        ),
        this._customVisionService.predict(receipt).pipe(
          map(value => value.predictions.slice(0, 3)),
          tap(value => this.predictions = value)
        ),
      ])),
    ).subscribe(([res1, res2]) => {
      this.formGroup.patchValue({
        paidOn: res1.paidOn,
        amount: res1.amount,
        supplierName: res2[0].tagName,
      });
    });

    this.categories$ = this._accountService.retrieveAllCategories().pipe(map(value => value.entities));
    this.users$ = this._accountService.retrieveAllUsers().pipe(map(value => value.entities));
    // this.formGroup.patchValue({ paidBy: this.me });
  }

  clear(name: string) {
    this.formGroup?.get(name)?.setValue('');
  }
}
